import { Component, EventEmitter, Output } from "@angular/core";
import { FormBuilder, Validators } from "@angular/forms";
import Validation from "src/app/shared/utils/helpers/validators/form-field-custom.validators";

@Component({
  selector: "app-invitation-password-form",
  templateUrl: "./invitation-password-form.component.html",
  styleUrls: ["./invitation-password-form.component.scss"],
})
export class InvitationPasswordFormComponent {
  @Output() passwordSubmit = new EventEmitter<string>();

  public form = this.fb.nonNullable.group(
    {
      password: ["", [Validators.required, Validation.password()]],
      confirmPassword: ["", [Validators.required]],
    },
    {
      validators: [Validation.match("password", "confirmPassword")],
    }
  );

  constructor(private fb: FormBuilder) {}

  public passwordVisible = false;
  public confirmationVisible = false;

  /**
   * Validates the form and emits the chosen password, or marks every field as touched to show
   * its errors when invalid.
   */
  public submit(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    this.passwordSubmit.emit(this.form.controls?.password?.value);
  }

  /**
   * Shows or hides the password field's value.
   */
  public togglePassword(): void {
    this.passwordVisible = !this.passwordVisible;
  }

  /**
   * Shows or hides the confirmation field's value.
   */
  public toggleConfirmation(): void {
    this.confirmationVisible = !this.confirmationVisible;
  }
}
